import { useTranslation } from "react-i18next"
import DangerActionCard from "../DangerActionCard"
import { Flex, Radio } from "antd"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"

const AccountDeletionOptions = ({ setSelected, selected }) => {
  const { t } = useTranslation()

  return (
    <Radio.Group value={selected} onChange={(e) => setSelected(e.target?.value)} className="w-full">
      <Flex vertical gap={spacings.XS}>
        <DangerActionCard
          title={t("settings.delete_options.stay_active_last_booking.title")}
          description={t("settings.delete_options.stay_active_last_booking.description")}
          showRadio
          radioProps={{ value: "active" }}
          isActionBtn={false}
        />

        <DangerActionCard
          title={t("settings.deactivate_profile.title")}
          description={t("settings.deactivate_profile.description")}
          showRadio
          radioProps={{ value: "deactivate" }}
          isActionBtn={false}
        />
      </Flex>
    </Radio.Group>
  )
}

AccountDeletionOptions.propTypes = {
  setSelected: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired
}

export default AccountDeletionOptions
